export interface InputResponse {
  topic: string,
  payload: any
};